<mat-card>
    <div class="flex-row flex-space-between p-20 bg-accent">
        <div>
            <mat-card-header>
                <mat-card-title>
                    My Badges
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon class="accent-text">close</mat-icon>
            </button>
        </div>
    </div>
    <mat-card-content class="scrollY">

        <p>
            Badges are a way for us to recognise and thank you for your participation within the online community.
            There
            are different ways for you to earn badges and some badges will be quicker and easier to earn than
            others.
        </p>
        <p>
            These are the badges that you have earned already. Three badges will be displayed in your profile area.
            Badges are ranked and the best badge you have earned will appear on your profile page. You will be able
            to
            see other members badges by clicking their profile picture and in the same way they will be able to see
            yours.
        </p>

        <h3>Received</h3>
        <p>
            These are badges you've already earned
        </p>
        <app-badge-progress [hideTooltip]="true" [limit]="999" [showInProgress]="false" [small]="false"
                            [user]="currentUser"></app-badge-progress>

        <h3>In Progress</h3>
        <p>
            These are the badges that you are working towards.
        </p>
        <app-badge-progress [hideTooltip]="true" [limit]="999" [showInProgress]="true" [small]="false"
                            [user]="currentUser"></app-badge-progress>
    </mat-card-content>
</mat-card>

@if (confetti) {
    <app-confetti></app-confetti>
}
